module.exports = __webpack_public_path__ + "b170350e7f394d125f50a78cdaab75be.svg";